/**
 * Download de arquivo no navegador. Único ponto do app que toca o DOM para isso — extraído do
 * `baixarCsv` do check-in (GUE-338), que agora delega para cá em vez de manter uma segunda cópia
 * da mesma dança de `<a download>`.
 *
 * O `revokeObjectURL` não é zelo: sem ele o Blob fica retido enquanto a aba viver, e um PDF de
 * certificado por clique vaza memória numa tela de listagem.
 */
export function baixarBlob(blob: Blob, nomeArquivo: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
